module.exports = __webpack_public_path__ + "img/securityImg2.4d1a32c3.png";